import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import InquiryPage from "./pages/inquiry";
import HomePage from "./pages/home";
import ShortRenwealPage from "./pages/shortRenewal";
import "./App.css"
import FullRenewalPage from "./pages/fullRenewal";
import NewFormPage from "./pages/newform";
import VerificationPage from "./pages/verification";
import RegisterPage from "./pages/register";
import ErrorPage from "./pages/error";
import VerifyEmailPage from "./pages/verifyemail";
import LoginPage from "./pages/login";
import DashboardPage from "./pages/dashboard";
import PolicyRenewalPage from "./pages/policynewal";

const App: React.FC = () => {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/online-quotation-inquiry" replace />} />
        <Route path="/test198" element ={<HomePage />} />
        <Route path="/online-quotation-inquiry" element={<InquiryPage />} />
        <Route path="/short-renewal" element ={<ShortRenwealPage />} />
        <Route path="/full-renewal" element ={<FullRenewalPage />} />
        <Route path="/newform" element ={<NewFormPage />} />
        <Route path="/verification" element ={<VerificationPage />} />
        <Route path="/register" element ={<RegisterPage />} />
        <Route path="/verifyemail" element ={<VerifyEmailPage />} />
        <Route path="/error" element ={<ErrorPage />} />
        <Route path="/login" element ={<LoginPage />} />
        <Route path="/dashboard" element ={<DashboardPage />} />
        <Route path="/policynewal" element ={<PolicyRenewalPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;

